import { useNavigate } from "react-router-dom";

const articles = [
  {
    title: "How Much Does Tree Trimming Cost? (2026 Guide)",
    excerpt: "Everything you need to know about tree trimming prices — from small ornamental trees to towering oaks. Updated with real contractor data.",
    category: "Pricing",
    date: "Apr 2026",
    readTime: "6 min read",
    img: "https://public.readdy.ai/ai/img_res/7e0143620cc40d8f1909a93d7aa708c0.jpg",
    href: "/cost-guide",
  },
  {
    title: "Tree Removal Cost: What to Expect in 2026",
    excerpt: "Tree removal prices vary widely. Learn what factors drive costs up or down and how to get the best deal from a local pro.",
    category: "Pricing",
    date: "Mar 2026",
    readTime: "5 min read",
    img: "https://readdy.ai/api/search-image?query=tree%20removal%20crew%20cutting%20down%20large%20dead%20tree%20with%20crane%20equipment%20suburban%20neighborhood%20safety%20gear%20professional&width=600&height=380&seq=article-002&orientation=landscape",
    href: "/cost-guide",
  },
  {
    title: "How Much Does Stump Grinding Cost?",
    excerpt: "Stump grinding is often overlooked but essential. Find out average costs, what affects pricing, and whether DIY is worth it.",
    category: "Pricing",
    date: "Feb 2026",
    readTime: "4 min read",
    img: "https://readdy.ai/api/search-image?query=stump%20grinding%20machine%20removing%20tree%20stump%20in%20backyard%20yard%20green%20grass%20suburban%20home%20professional%20equipment&width=600&height=380&seq=article-003&orientation=landscape",
    href: "/cost-guide",
  },
  {
    title: "5 Questions to Ask a Tree Service Before Hiring",
    excerpt: "Don't get burned by an unlicensed contractor. These 5 questions will help you vet any tree service company before signing anything.",
    category: "Tips",
    date: "Jan 2026",
    readTime: "3 min read",
    img: "https://readdy.ai/api/search-image?query=homeowner%20talking%20with%20professional%20tree%20service%20contractor%20in%20backyard%20discussing%20tree%20work%20estimate%20clipboard%20sunny%20day&width=600&height=380&seq=article-004&orientation=landscape",
    href: "/cost-guide",
  },
];

export default function ContentGuide() {
  const navigate = useNavigate();

  return (
    <section className="bg-[#F7F9F8] py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
          <div>
            <span className="inline-block text-[#1B4332] text-xs font-bold uppercase tracking-widest mb-2">
              The Homeowners Guide
            </span>
            <h2 className="text-2xl md:text-3xl font-extrabold text-[#1B4332]">
              Tree Service Guides &amp; Pricing Articles
            </h2>
          </div>
          <a
            href="/cost-guide"
            onClick={(e) => { e.preventDefault(); navigate("/cost-guide"); }}
            className="text-[#1B4332] font-semibold text-sm hover:underline cursor-pointer whitespace-nowrap flex items-center gap-1"
          >
            See all articles <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {articles.map((article) => (
            <a
              key={article.title}
              href={article.href}
              onClick={(e) => { e.preventDefault(); navigate(article.href); }}
              className="bg-white rounded-2xl overflow-hidden border border-gray-100 hover:border-[#1B4332]/30 transition-colors cursor-pointer group"
            >
              <div className="w-full h-44 overflow-hidden">
                <img
                  src={article.img}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs font-bold text-[#1B4332] bg-[#E8F5E9] px-2 py-0.5 rounded-full whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="text-xs text-gray-400">{article.readTime}</span>
                </div>
                <h3 className="font-bold text-[#1B4332] text-sm leading-snug mb-2 group-hover:underline">
                  {article.title}
                </h3>
                <p className="text-gray-500 text-xs leading-relaxed line-clamp-2">{article.excerpt}</p>
                <p className="text-xs text-gray-400 mt-3">{article.date}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
